How well the candidate answered the question against the hirer's preferences.

The score is calculated differently based on the `responseTypeCode`:

- For `FreeText`, the score will be null.
- For `MultiSelect`, the score will be between 0 and 1 as a floating point.
  For example, if the candidate selected half of the preferred answers, the score would be 0.5.
- For `SingleSelect`, the score will be either 1 or 0 based off whether or not the candidate selected a preferred answer.
